import { Injectable } from "@angular/core";
import { BehaviorSubject, distinctUntilChanged, noop, tap } from "rxjs";
import { StoreChangesService } from "./store-changes.service";
import { WindowRefService } from './window-ref.service';
import { BrowserService } from "./browser.service";

interface CrispWindow extends Window {
  $crisp: any[];
  CRISP_WEBSITE_ID?: string;
}

@Injectable({ providedIn: 'root' })
export class CrispChatService {
  private readonly CRISP_WEBSITE_ID = 'f3f6e414-db78-41e3-baa5-7f5008c19a60';
  private crispWindow: CrispWindow | null | undefined;
  count = 0;

  constructor(
    private _storeChangesService: StoreChangesService,
    private windowRef: WindowRefService,
    private browserService: BrowserService
  ) {
  }

  onInit() {
    if (this.browserService.getWindow() && this.browserService.getLocation()) {

      this.crispWindow = this.windowRef.nativeWindow as CrispWindow;
      this.crispWindow.$crisp?.push(['safe', true])
      if (this.crispWindow && !location.href.includes('admin')) {
        this.initialize();
        this.checkUser();
      }
    }
  }

  checkUser() {
    this._storeChangesService.getUser().pipe(
      distinctUntilChanged(),
      tap(user => {
        if (user?._id) {
          if (this.count) this.resetSession();
          const { _id, name, email } = user;
          this.setUserData({ email, name, id: _id });
          this.initialize();
        } else if (this.count) {
          this.resetSession(); // logout case
        }
      })
    ).subscribe(noop);
  }

  crispChat = new BehaviorSubject<string>('init');

  initialize(): void {
    this.count++;
    if (!this.crispWindow) return;
    if (this.crispWindow.$crisp) return;

    this.crispWindow.$crisp = [];
    this.crispWindow.CRISP_WEBSITE_ID = this.CRISP_WEBSITE_ID;

    const script = document.createElement('script');
    script.src = 'https://client.crisp.chat/l.js';
    script.async = true;
    document.head.appendChild(script);

  }

  setUserData(user: { email: string, name: string, id: string }): void {

    if (!this.crispWindow?.$crisp) return;

    this.crispWindow.$crisp.push(["set", "user:email", [user.email]]);
    this.crispWindow.$crisp.push(["set", "user:nickname", [user.name]]);
    this.crispWindow.$crisp.push(["set", "session:user_id", [[user.id]]]);
  }

  resetSession(): void {
    if (!this.crispWindow?.$crisp) return;

    this.crispWindow.$crisp.push(["do", "session:reset"]);
  }
}
